import React from "react"
import { ZendeskNavItemAndIcon } from "./NavItemAndIcon"

function HelpCenterNav(): JSX.Element {
  return <ZendeskNavItemAndIcon icon="icn-support-buoy" id="nav-support-center-link" text={"Get help"} />
}

export { HelpCenterNav }
